import React, { useState } from 'react';
import axios from 'axios';
import { UserCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shown when the email belongs to a deactivated staff member of this clinic.
// Reactivates them with the role / branches just filled in; their old password keeps working.
export default function ReactivateHint({ hint, form, onDone }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const reactivate = async () => {
    setBusy(true); setErr('');
    try {
      const base = { active: true, ...(form.name ? { name: form.name } : {}), ...(form.phone ? { phone: form.phone } : {}) };
      await axios.put(`${API}/settings/staff/${hint.user_id}`, base);
      await axios.put(`${API}/settings/staff/${hint.user_id}/role`, { role: form.role, branch_ids: form.branch_ids || [] });
      onDone(form.name || hint.name);
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErr(typeof d === 'string' ? d : (d?.message || 'Could not reactivate'));
    } finally { setBusy(false); }
  };

  return (
    <div className="mb-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-xs text-amber-900" data-testid="staff-reactivate-hint">
      <div>{hint.message}</div>
      <div className="mt-1 text-[11px] text-amber-800">They'll get the role and branches you picked in this form, and sign in with their old password.</div>
      {err && <div className="mt-1.5 text-rose-700" data-testid="staff-reactivate-error">{err}</div>}
      <button type="button" onClick={reactivate} disabled={busy} data-testid="staff-reactivate-btn"
        className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-amber-600 px-3 py-1.5 text-[12px] font-semibold text-white hover:bg-amber-700 disabled:opacity-50">
        <UserCheck size={13} /> {busy ? 'Reactivating…' : 'Reactivate this person'}
      </button>
    </div>
  );
}
